import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/sendBox/Toolbar.module_built.css";
const classes = {"sendbox__toolbar-separator":"weDCCeq_sendbox__toolbar-separator","sendbox__toolbar-button":"weDCCeq_sendbox__toolbar-button","sendbox__toolbar-button--selected":"weDCCeq_sendbox__toolbar-button--selected","sendbox__toolbar":"weDCCeq_sendbox__toolbar"}
export default classes

const _sendbox__toolbar_separator0 = classes["sendbox__toolbar-separator"]
export { _sendbox__toolbar_separator0 as "sendbox__toolbar-separator" }

const _sendbox__toolbar_button0 = classes["sendbox__toolbar-button"]
export { _sendbox__toolbar_button0 as "sendbox__toolbar-button" }

const _sendbox__toolbar_button__selected0 = classes["sendbox__toolbar-button--selected"]
export { _sendbox__toolbar_button__selected0 as "sendbox__toolbar-button--selected" }

const _sendbox__toolbar0 = classes["sendbox__toolbar"]
export { _sendbox__toolbar0 as "sendbox__toolbar" }
